module.exports = "<img src=\"{{ model }}\" alt=\"imagen\"/>\n"